// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__o_vkH","title":"card_title__diARg","inActive":"card_inActive__2PTVQ"};